import apiClient from "../../utils/api.client";
import { getSaaId } from "../../utils/session.utils";

const saaServiceName = process.env.REACT_APP_SAA_SERVICE_NAME || "saaServices";
export const getMaxDailyAmountByOrganizationId = async () => {
  const saaId = getSaaId();
  const response = await apiClient.get(
    `/saaServices/${saaServiceName}/services/abaco/maximportediariotodas?organizacionId=${saaId}`,
  );
  const data = response.data;
  return data;
};

export const updateMaxDailyAmountByPdv = async (organizationId, cLogic, iMicst, cUsuar) => {
  const response = await apiClient.put(
    `/saaServices/${saaServiceName}/services/abaco/maximportediario?organizacionId=${organizationId}&cLogic=${cLogic}&iMicst=${iMicst}&cUsuar=${cUsuar}`,
  );
  return response.data;
};